var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal-pop", {
    attrs: {
      opened: _vm.appExitModalOpended,
      "no-negative-button": true,
      confirm: "MCOM-0000006",
      cancel: "MCOM-0000005"
    },
    on: {
      "update:opened": function($event) {
        _vm.appExitModalOpended = $event
      },
      confirm: _vm.appExit
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function() {
          return [
            _c("strong", { staticClass: "text-info" }, [
              _vm._v(
                _vm._s(
                  /*KB Global 앱을 종료하시겠습니까?*/ _vm.$t(
                    "MMAIN-03-01-01-18"
                  )
                )
              )
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }